var _effectorFileName = "/builds/gmini/front-ui-kit/src/ScrollBar/ScrollBar.styled.ts";
import styled, { css } from 'styled-components';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
export const ScrollBarStyled = styled(SimpleBar)`
  display: flex;
  overflow: auto;
  position: relative;
  flex-grow: 1;

  .simplebar-scrollbar::before {
    background: #fff;
    background: #e5e7f1;
    border-radius: 30px;
    opacity: 0;
  }

  & .simplebar-wrapper {
    & .simplebar-placeholder {
      width: 100% !important;
    }
  }

  & .simplebar-vertical .simplebar-scrollbar::before {
    width: 6px;
  }
  & .simplebar-horizontal .simplebar-scrollbar::before {
    height: 6px;
  }

  .simplebar-visible.simplebar-scrollbar::before {
    opacity: 1;
  }

  && {
    ${props => props.margin ? css`
            margin: ${props.margin};
          ` : ''};

    ${props => props.width ? css`
            width: ${props.width};
          ` : ''};

    ${props => props.height ? css`
            height: ${props.height};
          ` : ''};
  }
`;
export const Content = styled.div`
  && {
    ${props => props.additionalStyled ? props.additionalStyled : ''}
  }
`;